export { ErrorText } from './ErrorText.styles';
